import { Injectable } from '@angular/core';
import { CoreStore } from './core.store';
import { Observable } from 'rxjs';
import { AuthService } from './security/services/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Empresa } from './models';
import { Location } from '@angular/common';

@Injectable()
export class CoreFacade {
	colorInfo: string = 'info';
	colorDefault: string = 'default';
	colorDanger: string = 'danger';

	constructor(
		private coreStore: CoreStore,
		private authService: AuthService,
		private router: Router,
		private activeRoute: ActivatedRoute,
		private location: Location
	) {
		// activeRoute.paramMap.subscribe(params => {
		// 	if (params.has('empresaId')) {
		// 		let empresaId: number = parseInt(params.get('empresaId'));
		// 		if (empresaId === this.getEmpresaId) {
		// 			let empresa: Empresa[] = coreStore.getUserEmpresas.filter(empresa => empresa.id == empresaId);
		// 			if (empresa.length === 1) {
		// 				router.navigate(['/empresas', empresaId]);
		// 				this.setEmpresa = empresa[0];
		// 				this.setEmpresaId = empresaId;
		// 			} else {
		// 				router.navigate(['/home']);
		// 			}
		// 		}
		// 	}
		// });
		authService.currentUser$.subscribe(user => {
			let route = this.activeRoute.snapshot;
			let codeParam = route.queryParams.code ? true : false;

			if (codeParam && user.empresas && user.empresas.length === 1) {
				router.navigate(['/empresas', user.empresas[0].id]);
			} else if (codeParam && user.empresas && user.empresas.length > 1) {
				router.navigate(['/empresas']);
			}
		});
	}

	set setEmpresaId(empresaId: number) {
		this.coreStore.setEmpresaId = empresaId;
	}

	get getEmpresaId$(): Observable<number> {
		return this.coreStore.getEmpresaId$;
	}

	get getEmpresaId(): number {
		return this.coreStore.getEmpresaId;
	}

	set setEmpresa(empresa: Empresa) {
		this.coreStore.setEmpresa = empresa;
	}

	get getEmpresa$() {
		return this.coreStore.getEmpresa$;
	}

	get getEmpresa() {
		return this.coreStore.getEmpresa;
	}

	set setUserEmpresas(empresas: Empresa[]) {
		this.coreStore.setUserEmpresas = empresas;
	}

	get getUserEmpresas$() {
		return this.coreStore.getUserEmpresas$;
	}

	get getUserEmpresas() {
		return this.coreStore.getUserEmpresas;
	}

	get getUser$() {
		return this.authService.currentUser$;
	}

	goBack() {
		this.location.back();
	}

	processParamEmpresaId(empresaId: number): void {
		if (empresaId) {
			if (empresaId !== this.getEmpresaId) {
				let empresas: Empresa[] = [];
				if (this.coreStore.getUserEmpresas) {
					empresas = this.coreStore.getUserEmpresas.filter(empresa => empresa.id == empresaId);
				} else {
					empresas = this.authService.getUser().empresas.filter(empresa => empresa.id == empresaId);
				}

				if (empresas.length === 1) {
					this.setEmpresa = empresas[0];
					this.setEmpresaId = empresaId;
				}
			}
		}
	}
}
